import React, { useEffect, useState } from "react";
import Footer from "../components/Footer";
import Header from "../components/Header";
import axios from "axios";
import KeyboardArrowLeftOutlinedIcon from "@mui/icons-material/KeyboardArrowLeftOutlined";
import { useNavigate } from "react-router-dom";
import AnimatedPage from "../components/AnimatedPage";

function CSKH() {
    const [profile, setProfile] = useState(JSON.parse(localStorage.getItem("profile")));
    const [setting, setSetting] = useState(JSON.parse(localStorage.getItem("setting")));
    const [isLoading, setIsLoading] = useState(false);
    
    const navigate = useNavigate();

    const handleBackClick = () => {
        navigate(-1);
    };

    axios.interceptors.request.use(
        (config) => {
            const token = localStorage.getItem("user");
            if (token) {
                config.headers["Authorization"] = `Bearer ${token}`;
            }
            return config;
        },
        (error) => {
            return Promise.reject(error);
        }
    );

    useEffect(() => {
        setIsLoading(true);
        const timer = setTimeout(() => {
            setIsLoading(false);
        }, 2000);
        return () => clearTimeout(timer);
    }, []);

    useEffect(() => {
        axios.get(`${process.env.REACT_APP_API_URL}/setting/get`, {}).then((res) => {
            if (setting !== res.data.data[0]) {
                setSetting(res.data.data[0]);
                localStorage.setItem("setting", JSON.stringify(res.data.data[0]));
            }
        });
        axios
            .get(`${process.env.REACT_APP_API_URL}/auth/getUser`, {})
            .then((res) => {
                if (profile !== res.data.data) {
                    setProfile(res.data.data);
                    localStorage.setItem("profile", JSON.stringify(res.data.data));
                }
            })
            .catch((err) => localStorage.removeItem("user"));
    }, []);

    useEffect(() => {
        if (setting?.cskh?.length > 0) {
            if (setting.cskh.indexOf("t.me") !== -1 || setting.cskh.indexOf("facebook.com") !== -1 || setting.cskh.indexOf("zalo.me") !== -1) {
                //window.location.href = setting.cskh;
            }
        }
    }, [setting]);

    return (
        <AnimatedPage>
            <Header profile={profile} />

            <style>{`
                html, body, #root {
                    height: auto !important;
                    min-height: 100vh;
                    overflow-y: auto !important;
                    background-color: #e3e1e2 !important; 
                    margin: 0; padding: 0;
                }
                
                .cskh-wrapper {
                    padding-bottom: 100px;
                    background-color: #e3e1e2;
                    min-height: 100vh;
                }

                /* ================================================== */
                /* 1. BANNER THÔNG TIN USER                           */
                /* ================================================== */
                .center-head {
                    width: 100%;
                    height: 180px;
                    background: url('https://dztwieyphe62d.cloudfront.net/content/images/main/user/banner-center.jpg') center top no-repeat;
                    background-size: cover;
                    padding: 0 20px; 
                    display: flex;
                    align-items: center; 
                    color: #fff;
                    box-shadow: 0 2px 5px rgba(0,0,0,0.2);
                }
                .profile-avatar-wrapper { position: relative; margin-right: 15px; flex-shrink: 0; }
                .profile-avatar { width: 65px; height: 65px; background-color: #fff; border-radius: 50%; display: flex; justify-content: center; align-items: center; }
                .profile-avatar i { font-size: 38px; color: #ffca28; }
                .profile-v1-badge { position: absolute; top: -2px; right: -5px; background-color: #ff9800; color: #fff; border-radius: 50%; width: 20px; height: 20px; display: flex; justify-content: center; align-items: center; font-size: 11px; font-weight: bold; border: 2px solid #222; }
                .profile-info { flex: 1; display: flex; flex-direction: column; justify-content: center; text-align: left; }
                .profile-info h3 { margin: 0 0 2px 0; font-size: 16px; font-weight: bold; color: #fff; }
                .profile-info p.email { margin: 0 0 6px 0; font-size: 13px; color: #ddd; }
                .profile-stats p { margin: 2px 0; font-size: 13px; color: #fff; }
                .profile-stats span { color: #ff9800; font-weight: bold; }

                /* ================================================== */
                /* 2. TIÊU ĐỀ TRANG VÀ NÚT BACK                       */
                /* ================================================== */
                .page-header-box {
                    display: flex;
                    align-items: center;
                    padding: 15px;
                    background: transparent;
                }
                .back-btn {
                    background: #fff;
                    color: #b71c1c;
                    width: 35px;
                    height: 35px;
                    border-radius: 50%;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    cursor: pointer;
                    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
                    margin-right: 15px;
                }
                .back-btn:active { background: #f0f0f0; }
                .page-title-h1 {
                    font-size: 18px;
                    font-weight: bold;
                    color: #333;
                    margin: 0;
                    text-transform: uppercase;
                }

                /* ================================================== */
                /* 3. NỘI DUNG CHÍNH (THẺ CSKH)                       */
                /* ================================================== */
                .cskh-content {
                    padding: 0 15px 20px 15px;
                }

                .cskh-cover-img {
                    width: 100%;
                    border-radius: 10px;
                    box-shadow: 0 4px 10px rgba(0,0,0,0.15);
                    margin-bottom: 20px;
                }

                .cskh-card {
                    background: #fff;
                    border-radius: 8px;
                    padding: 20px 15px;
                    box-shadow: 0 2px 6px rgba(0,0,0,0.08);
                    text-align: center;
                }
                
                .cskh-card h3 {
                    font-size: 18px;
                    color: #333;
                    margin: 0 0 10px 0;
                }
                .cskh-card p {
                    font-size: 14px;
                    color: #666;
                    margin: 0 0 20px 0;
                    line-height: 1.5;
                }

                .btn-cskh-modern {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    background: #b71c1c;
                    color: #fff;
                    padding: 14px 20px;
                    border-radius: 8px;
                    text-decoration: none;
                    font-size: 16px;
                    font-weight: bold;
                    margin-bottom: 12px;
                    box-shadow: 0 4px 6px rgba(183, 28, 28, 0.3);
                    transition: transform 0.2s, background 0.3s;
                }
                .btn-cskh-modern:active {
                    transform: scale(0.98);
                    background: #961616;
                }
                .btn-cskh-modern i {
                    margin-right: 10px;
                    font-size: 20px;
                }
            `}</style>

            <div className="cskh-wrapper">
                
               

                {/* 2. TIÊU ĐỀ TRANG */}
                <div className="page-header-box">
                 
                    <h1 className="page-title-h1">Hỗ trợ khách hàng</h1>
                </div>

                {/* 3. NỘI DUNG CHÍNH */}
                <div className="cskh-content">
                    {/* Ảnh bìa */}
                    <img 
                        src={require("../../img/CSKH-cover-blue@2x.7365166c.png")} 
                        alt="CSKH Cover" 
                        className="cskh-cover-img"
                    />

                    {/* Thẻ chứa các nút hỗ trợ */}
                    <div className="cskh-card">
                        <h3>Liên hệ với chúng tôi</h3>
                        <p>Nếu bạn gặp bất kỳ vấn đề nào trong quá trình trải nghiệm, vui lòng liên hệ với đội ngũ CSKH trực tuyến 24/7.</p>

                        <a href={setting?.cskh} target="_blank" rel="noreferrer" className="btn-cskh-modern">
                            <i className="fa-solid fa-headset"></i> Chăm sóc khách hàng 1
                        </a>

                        {setting?.cskh2 && setting?.cskh2 !== "" && (
                            <a href={setting?.cskh2} target="_blank" rel="noreferrer" className="btn-cskh-modern" style={{ background: "#1976d2", boxShadow: "0 4px 6px rgba(25, 118, 210, 0.3)" }}>
                                <i className="fa-solid fa-headset"></i> Chăm sóc khách hàng 2
                            </a>
                        )}
                    </div>
                </div>
            </div>

            {isLoading && (
                <div className="loading" >
                    <div className="loader"></div>
                </div>
            )}

            <Footer />
        </AnimatedPage>
    );
}

export default CSKH;